/* SKU and PRJ ids carry five digits since 2026-09-15 (Jay, 2026-09-14) — SKU-00664, PRJ-00187.
   Three ran out: September added 147 SKUs in fifteen days, and SKU-1000 sorts BEFORE SKU-999 in
   every text sort the portal, the sheets and Excel do. `sql/20260915k` padded every stored id.

   What is still out there in three digits is every LINK written before that day: approval mails,
   ticket mails, a home card somebody pinned, a bookmark. The server pads an id arriving in a URL
   before any route sees it, which covers the API; this covers the screens, which read the same
   parameters themselves and compare them against rows in the browser.

   Only 1-4 digits are padded, so an id that is already five stays exactly as it is, and SMP / TSK /
   CP ids — different series, their own widths — are left alone. */
export const ID_PAD = 5;

export const padProjectId = (value) => String(value || '').replace(
    /(SKU|PRJ)-(\d{1,5})(?!\d)/g,
    (whole, tag, digits) => (digits.length >= ID_PAD ? whole : `${tag}-${digits.padStart(ID_PAD, '0')}`),
);

export default padProjectId;
